import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { RefreshableItem } from '../models/refreshableItem';
import { ValidateProductParams } from '../utilities/urlParameters';

export const getRefreshableItemsFromScopes = (scope: string) => {
  const requestedRefreshableItems = [
    RefreshableItem.CHECKING_ACCOUNTS,
    RefreshableItem.SAVING_ACCOUNTS,
    RefreshableItem.CREDITCARD_ACCOUNTS,
    RefreshableItem.LOAN_ACCOUNTS,
    RefreshableItem.INVESTMENT_ACCOUNTS,
    RefreshableItem.EINVOICES,
    RefreshableItem.TRANSFER_DESTINATIONS,
  ];

  if (scope.includes('transactions:read')) {
    requestedRefreshableItems.push(
      RefreshableItem.CHECKING_TRANSACTIONS,
      RefreshableItem.SAVING_TRANSACTIONS,
      RefreshableItem.CREDITCARD_TRANSACTIONS,
      RefreshableItem.LOAN_TRANSACTIONS,
      RefreshableItem.INVESTMENT_TRANSACTIONS
    );
  }

  if (scope.includes('identity:read')) {
    requestedRefreshableItems.push(RefreshableItem.IDENTITY_DATA);
  }

  if (scope.includes('beneficiaries:read')) {
    requestedRefreshableItems.push(RefreshableItem.LIST_BENEFICIARIES);
  }

  return requestedRefreshableItems;
};

export const validateParams: ValidateProductParams = (commonParams) => {
  const errors = [];

  if (!commonParams.scope) {
    errors.push({
      errorStatus: ErrorStatus.BAD_REQUEST,
      errorReason: ErrorReason.INVALID_PARAMETER_SCOPE,
    });
  }

  return {
    parameters: {
      refreshableItems: getRefreshableItemsFromScopes(commonParams.scope || ''),
    },
    errors,
  };
};
